<template>
    <div class="nsfe-mensagem-erro">
        <div v-if="status == 3 || status == 7">
            <Alert type="danger">
                <span>
                    A emissão da NFS-e falhou.
                    <span class="link-error" @click="openModal('error')">
                        <b>CLIQUE AQUI</b>
                    </span> para verificar os
                    detalhes.
                </span>
            </Alert>
        </div>
        <Modal title="Erro" :width="650" :height="750" v-if="showModal('error')">
            <Alert type="danger">
                <span>
                    {{ mensagemErro }}
                </span>
            </Alert>
        </Modal>
    </div>
</template>
<script>

import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";

import { mapMutations, mapGetters } from "vuex";

export default {
    name: "NfseMensagemErro",
    props: ["status", "mensagemErro"],
    components: {
        Alert, Modal
    },
    methods: {
        ...mapMutations("generic", ["openModal"]),
    },
    computed: {
        ...mapGetters("generic", ["showModal"]),
    },
}
</script>
<style scoped>
.link-error {
    cursor: pointer;
}

.nsfe-mensagem-erro {
    margin-top: 10px;
}
</style>
